module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterEnter": _vm.afterEnter,
      "beforeLeave": _vm.beforeLeave,
      "afterLeave": _vm.afterLeave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1a8e0c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-expanding/src/Expanding.vue
// module id = 378
// module chunks = 66